import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getAllQa } from "../../../redux/services/qaSlice";
import {
  addReport,
  getQuestionByAiMentor,
  getQuestionById,
} from "../../../redux/services/reportSlice";
import Select from "react-select";
import ReportModel from "./ReportModel";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import logo from "../../../assests/BEFLogo.png"

const ViewSolution = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const qaData = useSelector((state) => state.qa.qaData);
  const viewData = qaData?.contest_type_data[0]?.answers;
  console.log("viewData",viewData);
  
  const queryParams = new URLSearchParams(location.search);
  const [filter, setFilter] = useState("all");
  const qaId = queryParams.get("qaId");
  const contestId = queryParams.get("contestId");
  const [showSolution, setShowSolution] = useState(false);
  const [reportIssue, setReportIssue] = useState(false);
  const [questionDataArray, setQuestionDataArray] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [finalMatchedData, setFinalMatchedData] = useState([]);
  const [aiMentorDataArray, setAiMentorDataArray] = useState([]);
  const [reportData, setReportData] = useState("");
  const [loading, setLoading] = useState(false);
  const [questionId, setQuestionId] = useState();
  const getReports = useCallback(async () => {
    try {
      await dispatch(getAllQa({ page: 1, limit: 1000, qaId: qaId }));
    } catch (error) {}
  }, [dispatch, qaId]);

  useEffect(() => {
    getReports();
  }, [getReports]);
 
  const handleQuestionById = useCallback(
    async (viewData) => {
      try {
        const responses = await Promise.all(
          viewData.map(async (item) => {
            const response = await dispatch(getQuestionById(item.questionId?._id));
            return response?.payload?.data;
          })
        );
console.log("responses",responses);

        setQuestionDataArray(responses);
      } catch (error) {
        console.error("Error fetching questions", error);
      }
    },
    [dispatch]
  );
  const handleAiMentor = useCallback(async () => {
    try {
      const responses = await Promise.all(
        viewData.map(async (item) => {
          const response = await dispatch(
            getQuestionByAiMentor(item.questionId?._id)
          );
          return response?.payload?.data;
        })
      );
      setAiMentorDataArray(responses);
    } catch (error) {}
  }, [dispatch, viewData]);
  useEffect(() => {
    if (viewData && viewData.length > 0) {
      handleQuestionById(viewData);
      handleAiMentor(viewData);
    }
  }, [viewData, handleQuestionById, handleAiMentor]);

  const handleNext = () => {
    setCurrentQuestionIndex((prev) =>
      Math.min(prev + 1, finalMatchedData.length - 1)
    );
  };

  const handlePrevious = () => {
    setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let payload = {
      contestId: contestId?.toString(),
      qaId: qaId,
      questionId: questionId,
      message: reportData,
    };
    setLoading(true);
    try {
      const response = await dispatch(addReport(payload));
      if (response.payload.status === 200) {
        setReportData("");
        setLoading(false);
        setReportIssue(false);
        toast.success(response.payload?.message);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const solutionOptions = [
    { value: "all", label: "All Solutions" },
    { value: "correct", label: "Correct" },
    { value: "incorrect", label: "Incorrect" },
    { value: "unanswered", label: "Unanswered" },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.375rem",
      borderColor: "#D1D5DB",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#124699",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#124699" : "white",
      color: state.isSelected ? "white" : "#4B5563",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: state.isSelected ? "#124699" : "#e8effa",
        color: state.isSelected ? "white" : "#4B5563",
      },
    }),
  };
  // console.log("finalMatchedData ",finalMatchedData)
  const scoreTexts = finalMatchedData?.map((question) => {
    const matchingViewData = viewData?.find(
      (item) => item.questionId?._id === question?._id
    );
    // console.log(matchingViewData)
    const userAnswer = matchingViewData?.answer;
    const correctAnswer = question?.englishQuestion?.answer;
    const is2XStack = matchingViewData?.is2XStack;
    const strategyType = question?.strategyType;

    let scoreText = "N/A"; 

    if (strategyType !== "skip") {
      if (is2XStack) {
        scoreText = userAnswer === correctAnswer ? "+4 Marks" : "-1.34 Marks";
      } else {
        scoreText = userAnswer === correctAnswer ? "+2 Marks" : "-0.67 Marks";
      }
    }

    return scoreText;
  });
  const filteredViewData = viewData?.filter((item, index) => {
    
    const userAnswer = item.answer;
    const correctAnswer = questionDataArray[index]?.englishQuestion?.answer;

    if (filter === "correct" && userAnswer === correctAnswer) {
      return true;
    }
    if (filter === "incorrect" && userAnswer !== correctAnswer) {
      return true;
    }
    if (filter === "unanswered" && !userAnswer) {
      return true;
    }
    return filter === "all";
  });

  useEffect(() => {
    if (
      filteredViewData &&
      filteredViewData.length > 0 &&
      questionDataArray &&
      questionDataArray.length > 0
    ) {
      const matchedData = filteredViewData
        .map((filteredItem) => {
const matchedQuestion = questionDataArray.find(
  (question) => question._id === filteredItem.questionId?._id
);

          if (matchedQuestion) {
            return {
              ...matchedQuestion,
              userAnswer: filteredItem.answer,
              type: filteredItem.type,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      if (JSON.stringify(matchedData) !== JSON.stringify(finalMatchedData)) {
        
        setFinalMatchedData(matchedData);
      }
    }
  }, [filteredViewData, questionDataArray, finalMatchedData]);

  const generatePDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const margin = 8;
    const maxYPosition = 270;
    const textWidth = pageWidth - 4 * margin;
    const logoWidth = 20;
    const logoHeight = 20;
    const topMargin = margin;
    const leftMargin = margin;
    const rightMargin = margin;
    const bottomMargin = margin;
    let y = topMargin;
    const addHeader = () => {
      doc.addImage(logo, "JPEG", leftMargin, y, logoWidth, logoHeight);
      doc.link(leftMargin, y, logoWidth, logoHeight, {
        url: "https://hkdigiverse.com",
      });
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      const textX = leftMargin + logoWidth + 5;
      doc.setTextColor("#E96D22");
      const bharatText = "BHARAT";
      doc.text(bharatText, textX, y + 10);
      const bharatWidth = doc.getTextWidth(bharatText);
      doc.setTextColor(0, 0, 255);
      const examText = "EXAM";
      doc.text(examText, textX + bharatWidth + 3, y + 10);
      const examWidth = doc.getTextWidth(examText);
      doc.setTextColor(0, 128, 0);
      const festText = "FEST";
      doc.text(festText, textX + bharatWidth + examWidth + 6, y + 10);
      const festWidth = doc.getTextWidth(festText);
      doc.link(textX, y + 8, bharatWidth, 10, {
        url: "https://hkdigiverse.com",
      });
      doc.link(textX + bharatWidth + 5, y + 8, examWidth, 10, {
        url: "https://hkdigiverse.com",
      });
      doc.link(textX + bharatWidth + examWidth + 10, y + 8, festWidth, 10, {
        url: "https://hkdigiverse.com",
      });
      const easyText = "LEARN AND EARN";
      const easyTextY = y + 16;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.text(easyText, textX, easyTextY);
      doc.setFontSize(10);
      const address = [
        "S-251, Angel Business Center, near Sudama Chowk,",
        "Mota Varachha, Surat, Gujarat - 394101",
      ];
      address.forEach((line, index) => {
        doc.text(line, pageWidth - rightMargin, y + 5 + index * 6, {
          align: "right",
        });
      });
      y += 6 * address.length + 6;
      doc.setFont("helvetica", "bold");
      doc.text("Phone: +91 93279 97744", pageWidth - rightMargin, y, {
        align: "right",
      });
      y += 5;
      doc.line(leftMargin, y, pageWidth - rightMargin, y);
    };
    const addFooter = () => {
      doc.setFont("helvetica", "bold");
      const footerY = doc.internal.pageSize.height - bottomMargin;
      doc.setFontSize(10);
      doc.text("Email: ask@bharatexamfest.com", leftMargin, footerY);
      const poweredByText = "Powered By: HK Digiverse & IT Consultancy";
      doc.text(poweredByText, pageWidth - rightMargin, footerY, {
        align: "right",
      });
      const poweredByX =
        pageWidth - rightMargin - doc.getTextWidth(poweredByText);
      doc.link(poweredByX, footerY - 2, doc.getTextWidth(poweredByText), 10, {
        url: "https://hkdigiverse.com/",
      });
      const pageCount = doc.internal.getNumberOfPages();
      doc.text(`${pageCount}`, pageWidth / 2, footerY, { align: "center" });
    };
    const addNewPage = () => {
      doc.addPage();
      addFooter();
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      return 20;
    };
    addHeader();
    addFooter();
    doc.setFontSize(12);
    let yPosition = y + 10;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(`Subject:`, pageWidth / 2, yPosition, { align: "center" });
    yPosition += 10;
    doc.setFontSize(12);
    doc.text(`Total Questions: ${questionDataArray?.length || 0}`, 10, yPosition);
    yPosition += 2;
    questionDataArray?.forEach((q, index) => {
      if (index !== 0) { 
        yPosition = addNewPage(); 
      }
      yPosition += 10;
      if (yPosition + 15 > maxYPosition) yPosition = addNewPage();
      const questionText = `${index + 1}. ${q.englishQuestion?.question}`;
      const questionLines = doc.splitTextToSize(questionText, textWidth);
      doc.setFont("helvetica", "bold");
      doc.text(questionLines, 10, yPosition);
      yPosition += questionLines.length * 7;
      yPosition += 1;
      if (
        q.questionType === "statement" &&
        q.englishQuestion?.statementQuestion
      ) {
        q.englishQuestion.statementQuestion.forEach((statement, index) => {
          const statementText = `Statement ${index + 1}: ${statement.combined}`;
          const statementLines = doc.splitTextToSize(statementText, textWidth);
          if (yPosition + statementLines.length * 7 > maxYPosition) {
            yPosition = addNewPage();
          }
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(statementLines, 10, yPosition);
          yPosition += statementLines.length * 7;
        });
        if (q.englishQuestion.lastQuestion) {
          if (yPosition + 15 > maxYPosition) {
            yPosition = addNewPage();
          }
          const lastQuestionText = `${q.englishQuestion.lastQuestion}`;
          const lastQuestionLines = doc.splitTextToSize(
            lastQuestionText, 
            textWidth
          );
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(lastQuestionLines, 10, yPosition);
          yPosition += lastQuestionLines.length * 7;
        }
      }
      if (q.questionType === "pair" && q.englishQuestion?.pairQuestion) {
        const tableMargin = 10;
        let startY = yPosition;
        const tableData = q.englishQuestion.pairQuestion.map((pair) => {
          const parts = pair.combined.split(" --- ");
          return parts;
        });
        const table1Data = q.englishQuestion.pairQuestion
          .slice(1)
          .map((pair) => {
            const parts = pair.combined.split(" --- ");
            return parts;
          });
        const headers =
          tableData.length > 0 ? tableData[0].map((part, index) => part) : [];
        if (yPosition + 15 > maxYPosition) {
          yPosition = addNewPage();
        }
        doc.autoTable({
          startY: startY,
          head: [headers],
          body: table1Data,
          margin: { top: tableMargin },
          theme: "grid",
          headStyles: {
            fillColor: "#124699",
            textColor: "#fff",
            fontStyle: "bold",
            cellPadding: 5,
          },
          styles: {
            font: "helvetica",
            fontSize: 10,
            cellPadding: 4,
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          bodyStyles: {
            fillColor: "#f5f5f5",
            textColor: "#000",
            fontSize: 10,
            cellPadding: 4,
          },
        });
        yPosition = doc.lastAutoTable.finalY + 10;
        if (q.englishQuestion.lastQuestion) {
          if (yPosition + 15 > maxYPosition) {
            yPosition = addNewPage();
          }
          const lastQuestionText = ` ${q.englishQuestion.lastQuestion}`;
          const lastQuestionLines = doc.splitTextToSize(
            lastQuestionText,
            textWidth
          );
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(lastQuestionLines, tableMargin, yPosition);
          yPosition += lastQuestionLines.length * 7;
        }
      }
      if (q.englishQuestion?.options) {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        ["A", "B", "C", "D"].forEach((optionKey) => {
          if (q.englishQuestion.options[optionKey]) {
            const optionText = `${optionKey}) ${q.englishQuestion.options[optionKey]}`;
            const optionLines = doc.splitTextToSize(optionText, textWidth);
            if (yPosition + optionLines.length * 7 > maxYPosition)
              yPosition = addNewPage();
            doc.text(optionLines, 15, yPosition);
            yPosition += optionLines.length * 7;
          }
        });
      }
      if (q.englishQuestion?.answer) {
        if (yPosition + 10 > maxYPosition) yPosition = addNewPage();
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 128, 0);
        const correctAnswerText = `Correct Answer: ${q.englishQuestion.answer}`;
        doc.text(correctAnswerText, 10, yPosition);
        yPosition += 6;
      }
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);
      yPosition += 2;
      const solutionText = `Solution: ${q.englishQuestion?.solution}`;
      const solutionLines = doc.splitTextToSize(solutionText, textWidth);
      solutionLines.forEach((line, lineIndex) => {
        if (yPosition + 7 > maxYPosition) yPosition = addNewPage();
        doc.text(line, 10, yPosition);
        yPosition += 7;
      });
      yPosition += 1;
      const lineYPosition = yPosition;
      doc.setLanguage("hi");
      doc.setLineWidth(0.5);
      doc.line(margin, lineYPosition, pageWidth - margin, lineYPosition);
      
    });
    addFooter();
    doc.save(`Solution-data.pdf`);
  };

  return (
    <div className="min-h-full bg-gray-100 flex flex-col items-center p-3">
      <div className="w-full max-w-3xl bg-white shadow-lg rounded-lg p-6">
        <div className="flex justify-between">
          <div className="sm:w-72 w-full mb-4">
            <Select
              name="solution"
              className="w-full text-base h-[40px] rounded-md"
              value={solutionOptions.find((option) => option.value === filter)}
              onChange={(e) => setFilter(e ? e.value : "")}
              options={solutionOptions}
              classNamePrefix="custom-select"
              styles={customStyles}
            />
          </div>
          <button
            className="px-4 py-2 text-white font-semibold rounded-lg bg-[#124699] h-fit"
            onClick={generatePDF}
          >
            Export PDF
          </button>
        </div>
        <hr className="mb-4" />
        <div className="h-[600px] overflow-auto">
          {finalMatchedData.length > 0 && filteredViewData?.length > 0 && (
            <>
              <div className="mb-4">
                <p className="text-lg font-semibold">
                  Question {currentQuestionIndex + 1}
                </p>
                <p
                  className={`font-semibold ${
                    scoreTexts[currentQuestionIndex]?.includes("+")
                      ? "text-green-600"
                      : "text-red-500"
                  }`}
                >
                  {scoreTexts[currentQuestionIndex]}
                </p>
              </div>

              <p className="p-2 border border-gray-200 rounded-md mb-2 w-fit bg-gray-50">
                {finalMatchedData[currentQuestionIndex]?.subtopicId?.name}
              </p>

              <p className="p-2 border border-gray-200 rounded-md mb-2 w-fit bg-gray-50">
                <span className="font-medium"> Strategy:</span> 
                {filteredViewData[currentQuestionIndex]?.type || "N/A"}
              </p>
              {aiMentorDataArray[currentQuestionIndex] && (
                <div className="border border-gray-300 rounded-md p-3 mb-4 bg-gray-50">
                  <p className="text-center text-lg font-semibold">AI Mentor</p>
                  <p>
                    In This Subject: 
                    <span className="font-medium">
                      {aiMentorDataArray[currentQuestionIndex]?.type}
                    </span> 
                    Based Question
                  </p>
                  <p>
                    Other: 
                    <span className="font-medium">
                      {
                        aiMentorDataArray[currentQuestionIndex]?.otherStrategy
                          ?.strategyPercentage
                      }
                    </span> 
                    Accuracy Using Based Question 
                    <span className="font-medium">
                      {
                        aiMentorDataArray[currentQuestionIndex]?.otherStrategy
                          ?.strategyType
                      }
                    </span>
                  </p>
                  <p>
                    Your: 
                    <span className="font-medium">
                      {
                        aiMentorDataArray[currentQuestionIndex]?.youStrategy
                          ?.strategyPercentage
                      }
                    </span> 
                    Accuracy Using Based Question 
                    <span className="font-medium">
                      {
                        aiMentorDataArray[currentQuestionIndex]?.youStrategy
                          ?.strategyType
                      }
                    </span>
                  </p>
                </div>
              )}
              <div className="border border-gray-200 rounded-lg p-4 bg-white shadow">
                <p className="font-semibold">
                  {
                    finalMatchedData[currentQuestionIndex]?.englishQuestion
                      ?.question
                  }
                </p>
                {finalMatchedData[currentQuestionIndex]?.questionType ===
                  "statement" && (
                  <div className="p-3 border border-gray-300 bg-gray-50 rounded-md mt-2">
                    {finalMatchedData[
                      currentQuestionIndex
                    ]?.englishQuestion?.statementQuestion?.map((x, i) => {
                      return (
                        <p className="mt-2" key={i}>
                          {x?.combined}
                        </p>
                      );
                    })}
                  </div>
                )}
                {finalMatchedData[currentQuestionIndex]?.questionType ===
                  "pair" && (
                  <div className="p-3 border border-gray-300 rounded-md mt-2">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead>
                        <tr className="bg-gray-200">
                          {finalMatchedData[
                            currentQuestionIndex
                          ]?.englishQuestion?.pairQuestion?.[0]?.combined
                            .split(" --- ")
                            .map((header, index) => (
                              <th
                                key={index}
                                className="border border-gray-400 p-2 text-left"
                              >
                                {header}
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {finalMatchedData[
                          currentQuestionIndex
                        ]?.englishQuestion?.pairQuestion
                          ?.slice(1)
                          .map((row, rowIndex) => (
                            <tr
                              key={rowIndex}
                              className="border border-gray-300"
                            >
                              {row?.combined
                                .split(" --- ")
                                .map((cell, cellIndex) => (
                                  <td
                                    key={cellIndex}
                                    className="border border-gray-400 p-2"
                                  >
                                    {cell}
                                  </td>
                                ))}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {(finalMatchedData[currentQuestionIndex]?.questionType ===
                  "statement" ||
                  finalMatchedData[currentQuestionIndex]?.questionType ===
                    "pair") && (
                  <p className="mt-3 font-medium">
                    {
                      finalMatchedData[currentQuestionIndex]?.englishQuestion
                        ?.lastQuestion
                    }
                  </p>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  {Object.entries(
                    finalMatchedData[currentQuestionIndex]?.englishQuestion
                      ?.options
                  ).map(([key, value]) => {
                    const matchingViewData =
                      filteredViewData[currentQuestionIndex];
                    const userAnswer = matchingViewData?.answer;
                    const correctAnswer =
                      finalMatchedData[currentQuestionIndex]?.englishQuestion
                        ?.answer;
                    let bgColor = "bg-white border-gray-300";

                    if (key === correctAnswer) {
                      bgColor = "bg-green-100 border-green-500";
                    }
                    if (key === userAnswer && userAnswer !== correctAnswer) {
                      bgColor = "bg-red-100 border-red-500";
                    }

                    return (
                      <div
                        key={key}
                        className={`p-3 border rounded-lg flex items-center gap-3 ${bgColor}`}
                      >
                        <div className="w-8 h-8 flex justify-center items-center border border-gray-500 rounded-full">
                          <p className="font-medium">{key}</p>
                        </div>
                        <p className="w-[calc(100%-3rem)]">{value}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
              {showSolution && (
                <div className="text-gray-700 mt-5">
                  <p className="text-lg font-medium underline">Solution</p>
                  <p>
                    Correct answer : (
                    {
                      finalMatchedData[currentQuestionIndex]?.englishQuestion
                        ?.answer
                    }
                    )
                  </p>
                  <p
                    className="mt-4"
                    dangerouslySetInnerHTML={{
                      __html: finalMatchedData[
                        currentQuestionIndex
                      ]?.englishQuestion.solution.replace(/\n/g, "<br />"),
                    }}
                  ></p>
                </div>
              )}
            </>
          )}
        </div>
        <div className="flex justify-between mt-6">
          <button
            className={`px-4 py-2 text-white rounded-lg ${
              currentQuestionIndex === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#F48224] hover:bg-[#F48224]"
            }`}
            onClick={handlePrevious}
            disabled={currentQuestionIndex === 0}
          >
            Previous
          </button>
          <div className="flex flex-wrap gap-5">
            <button
              className="border border-red-700 px-4 py-2 rounded-lg text-red-700 bg-red-200"
              type="button"
              onClick={() => {
                setQuestionId(finalMatchedData[currentQuestionIndex]?._id);
                setReportIssue(true);
              }}
            >
              Report An Issue
            </button>
            <button
              className="border border-[#F48224] px-4 py-2 rounded-lg text-gray-700 bg-gray-50"
              type="button"
              onClick={() => setShowSolution(!showSolution)}
            >
              See Solution
            </button>
            <button
              className={`px-4 py-2 text-white rounded-lg ${
                currentQuestionIndex === finalMatchedData.length - 1
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#F48224]  hover:bg-[#F48224]"
              }`}
              onClick={handleNext}
              disabled={currentQuestionIndex === finalMatchedData.length - 1}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {reportIssue && (
        <ReportModel
          reportData={reportData}
          setReportData={setReportData}
          onClose={() => {
            setReportIssue(false);
          }}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </div>
  );
};

export default ViewSolution;
